import { render, staticRenderFns } from "./WeeklyTestDataView.vue?vue&type=template&id=25c87415&scoped=true"
import script from "./WeeklyTestDataView.vue?vue&type=script&lang=js"
export * from "./WeeklyTestDataView.vue?vue&type=script&lang=js"
import style0 from "./WeeklyTestDataView.vue?vue&type=style&index=0&id=25c87415&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c87415",
  null
  
)

export default component.exports